import ButtonBase from '@material-ui/core/ButtonBase';
import ImageSelector from 'components/ImageSelector';
import Spin from 'components/Spin';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { upload } from 'store/Orbita/Upload/actions';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  id: any;
  name: any;
  image?: any;
  upload_id: number;
  fileName: string;
  uploadType: string;
  onChange: any;
}

interface IState {
  cropperOpen: boolean;
  image: any;
  uploading: boolean;
}

class CropUploader extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      cropperOpen: false,
      image: props.image,
      uploading: false,
    };
  }

  dataURItoBlob(dataURI: any) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    let byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1]);
    else byteString = unescape(dataURI.split(',')[1]);
    // separate out the mime component
    let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to a typed array
    let ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
  }

  onCropComplete = async (img: any) => {
    if (img) {
      this.setState({ uploading: true, cropperOpen: false });
      try {
        await this.props.dispatch(upload(this.dataURItoBlob(img), this.props.uploadType, 'newphoto.png'));
        this.setState({ image: img, uploading: false });
        this.props.onChange(this.props.fileName, this.props.upload_id, img);
      } catch (error) {
        toast.error(error);
        this.setState({ uploading: false });
        this.props.onChange(this.props.fileName, '');
      }
    }
  };

  onCloseCrop = () => this.setState({ cropperOpen: false });

  openSelector = () => {
    this.setState({ cropperOpen: true });
  };

  componentDidUpdate(prevProps: any) {
    if (prevProps.image !== this.props.image && !Number(this.props.image)) {
      this.setState({ image: this.props.image });
    }
  }

  render() {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          borderColor: '#eeeeee',
          borderStyle: 'dashed',
          backgroundColor: '#fafafa',
          transition: 'border .3s ease-in-out',
          minHeight: '100px',
          maxHeight: '200px',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: 8,
          padding: 24,
          borderWidth: 2,
          borderRadius: 2,
        }}
      >
        {!this.state.image && !this.state.uploading && (
          <ButtonBase style={{ width: '100%', height: '100%', position: 'absolute' }} onClick={this.openSelector} id={this.props.id}>
            Escolha a imagem
          </ButtonBase>
        )}
        {this.state.image && !this.state.uploading && (
          <ButtonBase style={{ width: '100%', height: '100%' }} onClick={this.openSelector} id={this.props.id}>
            <img style={{ maxWidth: '100%', maxHeight: '200px' }} src={this.state.image} alt='cropuploader' />
          </ButtonBase>
        )}
        {this.state.uploading && <Spin />}
        <ImageSelector width={200} height={200} onClose={this.onCloseCrop} onComplete={this.onCropComplete} opened={this.state.cropperOpen} />
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  upload_id: state.orbita.Upload.upload.upload_id,
});

export default connect(mapStateToProps)(CropUploader);
